
import { Plus } from "lucide-react";

interface EmptyRuleStateProps {
  onAddClick: () => void;
}

export function EmptyRuleState({ onAddClick }: EmptyRuleStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="bg-primary/10 p-3 rounded-full mb-4 cursor-pointer">
        <Plus onClick={onAddClick} className="h-8 w-8 text-primary" />
      </div>
      <h3 className="text-lg font-medium mb-2">No rules yet</h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        Create your first rule to automate email responses
      </p>
    </div>
  );
}
